import { PhaseLayout } from "../../components/PhaseLayout";
import { StepGenerator } from "../../components/StepGenerator";

const STEPS = [
  {
    type: "bio_generator",
    title: "Bio Generator",
    description: "Craft professional bios in multiple lengths for different platforms.",
    fields: [
      { key: "name", label: "Your Name", placeholder: "e.g., Sarah Chen", required: true },
      { key: "role", label: "Title / Role", placeholder: "e.g., Business Strategist & Course Creator", required: true },
      { key: "achievements", label: "Key Achievements", placeholder: "e.g., Helped 500+ women launch digital products, Featured in Forbes", required: true, type: "textarea" },
      { key: "personal", label: "Personal Touch", placeholder: "e.g., Tea lover, book collector, mom of two", required: false },
      { key: "audience", label: "Target Audience", placeholder: "e.g., Speaking at business conferences, media interviews", required: true }
    ]
  },
  {
    type: "testimonial_framework",
    title: "Testimonial Framework",
    description: "Create a system for collecting powerful social proof.",
    fields: [
      { key: "product", label: "Product / Service", placeholder: "e.g., Business Blueprint Course", required: true },
      { key: "outcomes", label: "Ideal Client Outcomes", placeholder: "e.g., Launched first product, hit $10k month, found clarity", required: true, type: "textarea" },
      { key: "client_type", label: "Typical Client Type", placeholder: "e.g., Service provider transitioning to digital products", required: true }
    ]
  },
  {
    type: "case_study",
    title: "Case Study Template",
    description: "Document client success stories in a compelling format.",
    fields: [
      { key: "situation", label: "Client Situation (Before)", placeholder: "e.g., Overwhelmed service provider working 60hr weeks", required: true, type: "textarea" },
      { key: "challenge", label: "Main Challenge", placeholder: "e.g., Wanted passive income but didn't know where to start", required: true, type: "textarea" },
      { key: "solution", label: "Your Solution", placeholder: "e.g., 8-week 1:1 coaching + course creation support", required: true },
      { key: "results", label: "Results Achieved", placeholder: "e.g., Launched course in 6 weeks, $15k in first launch, 40hr weeks", required: true, type: "textarea" }
    ]
  },
  {
    type: "media_kit",
    title: "Media Kit Creator",
    description: "Prepare professional materials for press and podcast opportunities.",
    fields: [
      { key: "brand", label: "Brand Name", placeholder: "e.g., Calm Scale Studio", required: true },
      { key: "story", label: "Your Story", placeholder: "e.g., From burnt-out agency owner to calm business architect", required: true, type: "textarea" },
      { key: "topics", label: "Expert Topics", placeholder: "e.g., Introvert business strategy, sustainable scaling, digital products", required: true, type: "textarea" },
      { key: "features", label: "Previous Features (if any)", placeholder: "e.g., Forbes, Entrepreneur magazine, top podcasts", required: false }
    ]
  }
];

export default function AuthorityPhase() {
  return (
    <PhaseLayout 
      phaseNumber={3}
      phaseName="Authority"
      phaseSubtitle="Establish Credibility"
      phaseDescription="Build the credibility materials that establish you as a trusted expert. These assets work for you even when you're not visible."
      days="Days 8-10"
      nextPhase={{ number: 4, name: "Launch", path: "/phase/launch" }}
      prevPhase={{ number: 2, name: "Assets", path: "/phase/assets" }}
    >
      {STEPS.map((step, index) => (
        <StepGenerator
          key={step.type}
          room="authority"
          generatorType={step.type}
          stepNumber={index + 1}
          title={step.title}
          description={step.description}
          fields={step.fields}
          defaultOpen={index === 0}
        />
      ))}
    </PhaseLayout>
  );
}
